import React from 'react';
import { userTypes } from '../constants';
import AuditResourceLink from './AuditResourceLink';

const AuditWhoLink = ({ allowUserGroupLink, allowUserLink, audit }) => (
  <AuditResourceLink
    name={audit.user_name}
    route={audit.user_type === userTypes.USERGROUP ? `usergroups/${audit.usergroup_code}` : `users/${audit.who}`}
    allowUserLink={allowUserLink}
    allowUserGroupLink={allowUserGroupLink}
    entity={audit.user_type === userTypes.USERGROUP ? userTypes.USERGROUP : userTypes.USER}
  />
);

export default AuditWhoLink;
